// extracted by mini-css-extract-plugin
export var cardcontainer = "SignPostLinks-module--cardcontainer--db0ed";
export var childlink = "SignPostLinks-module--childlink--062dc";
export var childlinks = "SignPostLinks-module--childlinks--7425f";
export var parentlink = "SignPostLinks-module--parentlink--09d2f";
export var titlelink = "SignPostLinks-module--titlelink--914d2";